import type React from 'react';

import { Separator } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { ModuleSeparatorStyles } from './ModuleSeparator.styles';

type Props = {
	className?: string;
	orientation?: 'horizontal' | 'vertical';
};

export const ModuleSeparator: React.FC<Props> = ({ className, orientation = 'horizontal' }) => {
	const styles = ModuleSeparatorStyles({ orientation });
	return <Separator data-testid="inner-separator" className={cn(styles, className)} orientation={orientation} />;
};
